import {
  Component,
  inject,
  computed,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { ConfigService } from "../../../shared/config/config.service";
import { pathRouteDataHelper$ } from "../../../shared/helpers/path-params.helper";
import { AuthImagePipe } from "../../../shared/pipes/auth-image.pipe";

@Component({
  selector: "claas-product-tech-data-overview",
  imports: [AuthImagePipe, IconComponent, TranslatePipe],
  templateUrl: "./product-tech-data-overview.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-tech-data-overview.scss",
})
export class ProductTechDataOverview {
  route = inject(ActivatedRoute);
  config = inject(ConfigService);
  data = toSignal(pathRouteDataHelper$());
  techData = computed(() => this.data()?.["productTechData"]);
  productImage = computed(() => this.data()?.["productDetails"]?.["AssetLink"]);
}
